import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { Descriptions } from "antd"
import { ISimper } from "@/types"

interface EmployeeInfoCardProps {
  currentSimper: ISimper
}

const statusLabelMap: Record<string, string> = {
  active: "Aktif",
  berlaku: "Berlaku",
  expired: "Tidak Berlaku",
  "tidak berlaku": "Tidak Berlaku",
  pending: "Menunggu",
  "menunggu perpanjangan": "Menunggu Perpanjangan",
  inactive: "Tidak Aktif",
}

const EmployeeInfoCard = ({ currentSimper }: EmployeeInfoCardProps) => {
  const getStatusVariant = (status: string): "default" | "secondary" | "destructive" | "outline" | "success" | "pending" | "error" => {
    const s = status?.toLowerCase()
    if (s === "active" || s === "berlaku") return "success"
    if (s === "expired" || s === "tidak berlaku") return "destructive"
    if (s === "pending" || s === "menunggu perpanjangan") return "pending"
    return "secondary"
  }

  return (
    <Card className="mb-4 border-none shadow-sm overflow-hidden">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-4 bg-muted/20 border-b">
        <CardTitle className="text-xl font-bold text-primary-600">
          Employee Information
        </CardTitle>
        <Badge 
          className="px-3 py-1 text-xs font-semibold uppercase tracking-wider" 
          variant={getStatusVariant(currentSimper.simper_status)}
        >
          {statusLabelMap[currentSimper.simper_status?.toLowerCase() || ""] || currentSimper.simper_status}
        </Badge>
      </CardHeader>
      <CardContent className="pt-6">
        <Descriptions bordered column={{ xs: 1, sm: 2 }} size="small">
          <Descriptions.Item label="Simper Number" span={2}>
            <span className="font-bold text-lg text-primary-600">{currentSimper.simper_number}</span>
          </Descriptions.Item>
          <Descriptions.Item label="Employee ID">{currentSimper.employee_id}</Descriptions.Item>
          <Descriptions.Item label="Full Name">{currentSimper.name}</Descriptions.Item>
          <Descriptions.Item label="Department">{currentSimper.department}</Descriptions.Item>
          <Descriptions.Item label="Phone Number">{currentSimper.phone_number || "-"}</Descriptions.Item>
          <Descriptions.Item label="Blood Type">{currentSimper.blood_type || "-"}</Descriptions.Item>
          <Descriptions.Item label="Year / Month">{currentSimper.year} / {currentSimper.month}</Descriptions.Item>
        </Descriptions>
      </CardContent>
    </Card>
  )
}

export default EmployeeInfoCard
